import type { CatDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/pet';
import {
    getCoverageTermValue,
    formatAmountWithCurrency
} from '../coverableDetailsInsuranceSumsConfig';
import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import { type TableInformation } from '../../../../config/flavourConfig';

const getCatInsuranceSumsCoverableDetailsConfig = (catCoverable: CatDTO): TableInformation => {
    return {
        title: 'Forsikringssummer',
        rowsInformation: [
            {
                name: 'Udgifter til dyrlægeregninger pr. forsikringsår',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(catCoverable, 'PETHealthCov', 'PETHealthCovOptSum')
                ),
                valueType: 'amount',
                hidden:
                    getCoverageTermValue(catCoverable, 'PETHealthCov', 'PETHealthCovOptSum') === ''
            },
            {
                name: 'Karensperiode',
                fieldValue: `${getCoverageTermValue(
                    catCoverable,
                    'PETHealthCov',
                    'PETHealthCovWaitingPeriod'
                )} dage`,
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CAT-MODAL-WITHDRAWAL-PERIOD-TITLE',
                        description: 'DSS-CAT-MODAL-WITHDRAWAL-PERIOD-DESCRIPTION'
                    }
                },
                hidden:
                    getCoverageTermValue(
                        catCoverable,
                        'PETHealthCov',
                        'PETHealthCovWaitingPeriod'
                    ) === ''
            },
            {
                name: 'Bylder på hankatte',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(catCoverable, 'PETHealthCov', 'PETHealthCovOptAbscessSum')
                ),
                valueType: 'amount',
                hidden:
                    getCoverageTermValue(
                        catCoverable,
                        'PETHealthCov',
                        'PETHealthCovOptAbscessSum'
                    ) === ''
            },
            {
                name: 'Urinvejslidelser I de nedre urinveje (FLUTD) på hankatte',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(catCoverable, 'PETHealthCov', 'PETHealthCovFlutd')
                ),
                valueType: 'amount',
                hidden:
                    getCoverageTermValue(catCoverable, 'PETHealthCov', 'PETHealthCovFlutd') === ''
            },
            {
                name: 'Forsikringssum nedtrappes, når katten er',
                fieldValue:
                    getCoverageTermValue(
                        catCoverable,
                        'PETHealthCov',
                        'PETHealthSicknessReductionAgeCat'
                    ).split('.')[0] + ' år',
                hidden:
                    getCoverageTermValue(
                        catCoverable,
                        'PETHealthCov',
                        'PETHealthSicknessReductionAgeCat'
                    ) === ''
            },
            {
                name: 'Genoptræning',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        catCoverable,
                        'PETHealthPlusCov',
                        'PETHealthPlusCovOptRehabSum'
                    )
                ),
                valueType: 'amount',
                hidden:
                    getCoverageTermValue(
                        catCoverable,
                        'PETHealthPlusCov',
                        'PETHealthPlusCovOptRehabSum'
                    ) === ''
            },
            {
                name: 'Udleveret receptmedicin',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        catCoverable,
                        'PETHealthPlusCov',
                        'PETHealthPlusCovOptMedicineSum'
                    )
                ),
                valueType: 'amount',
                hidden:
                    getCoverageTermValue(
                        catCoverable,
                        'PETHealthPlusCov',
                        'PETHealthPlusCovOptMedicineSum'
                    ) === ''
            }
        ]
    };
};

export { getCatInsuranceSumsCoverableDetailsConfig };
